import { render } from "./FrmFamilyPreparationTemplatesModels.vue?vue&type=template&id=63627b99&scoped=true"
import script from "./FrmFamilyPreparationTemplatesModels.vue?vue&type=script&lang=js"
export * from "./FrmFamilyPreparationTemplatesModels.vue?vue&type=script&lang=js"

import "./FrmFamilyPreparationTemplatesModels.vue?vue&type=style&index=0&id=63627b99&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63627b99"]])

export default __exports__